import { ReactComponent as Error } from '@/assets/svgs/icon-error-message-exclamation.svg'
import Button from '@/components/Button'
import IconEye from '@/components/IconEye'
import Input from '@/components/Input/index'
import usePage from '@/hooks/use-page'
import useTwoFactorAuthentincation from "@/hooks/use-two-factor-authentication"
import { useNavigate } from '@/lib/router-dom'
import DexLeftComponent from '@/components/DexLeftComponent';
import { login } from '@/redux/actions/auth.js'
import api from '@/services/api/config.js'
import { feature, features } from '@/utils/feature-verifier'
import { getDexConfig } from '@/utils/get-dex-config'
import { getEnvAndDex } from "@/utils/get-env-and-dex"
import removeUrlTrailingSlash from '@/utils/remove-url-trailing-slash'
import { QRCodeSVG } from 'qrcode.react'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'

const Page = () => {

	/*=================================================
		General
	/================================================*/

	const dispatch = useDispatch()

	const { t } = useTranslation();

	const user = useSelector(state => state.auth.user)
	const environments = useSelector(state => state.auth.environments)

	console.log(user)

	usePage({ title: 'Activate Two-Factor Authentication' })

	const [customMask, setCustomMask] = useState(true);

	const [adminUrl, setAdminUrl] = useState()

	const [lockedAccount, setLockedAccount] = useState()

	/*=================================================
		API
	/================================================*/

	const { goTo } = useNavigate();
	const [errorMessage, setErrorMessage] = useState()

	const { register, handleSubmit, setError, formState: { errors, isValid } } = useForm({
		mode: 'onTouched'
	})

	const {currentItemTwoFactorAuthentication, fetchTwoFactorAuthentication} = useTwoFactorAuthentincation()

	async function fetchStatus() {
		const [error, data] = await api.checkStatus()

		if (error) {
			setError("Invalid pitstop URL. Please ensure that the URL is correct or contact the Administrator for assistance.")
		}

		const url = removeUrlTrailingSlash(data?.adminBaseUrl)
		setAdminUrl(url)
	}

	useEffect(()=> {
		fetchTwoFactorAuthentication()
		fetchStatus()

		if (localStorage.getItem("lockedTime")) {
			setLockedAccount(localStorage.getItem("lockedTime"))
		}

	}, [])


	const [loading, setLoading] = useState(false);

	/*=================================================
		API Action Functions
	/================================================*/

	const [checkCount, setCheckCount] = useState(0)

	async function formHandler(data) {
		if (loading) {
			return
		}
		setLoading(true)

		const payload = {
			secret: currentItemTwoFactorAuthentication?.secret,
			otp: data.otp
		}

		try {
			await dispatch(login(goTo, payload, "setUpTfa"))

			if (lockedAccount) {
				localStorage.removeItem('lockedTime')
				localStorage.removeItem('lockedAccount')
			}
		} catch (e) {
			setLoading(false)

			setCheckCount(checkCount + 1)

			if(e.message.toLowerCase() === "invalid credentials"){
				if (checkCount < 4) {
					setErrorMessage(`Invalid OTP, ${4 - checkCount} more consecutive failed attempts will lock the account`)
					return setError('otp', {
						type: "server",
						message: `Invalid OTP, ${4 - checkCount} more consecutive failed attempts will lock the account`
					})
				} else {
					const now = Date.parse(new Date())
					localStorage.setItem("lockedTime", now)
					localStorage.setItem("lockedAccount", user?.email)
					setLockedAccount(now)
					setErrorMessage(`Account locked, please retry after sometime`)
					return setError('otp', {
						type: "server",
						message: "Account locked, pls retry after  sometime"
					})
				}
			}
		}
	}

	/*=================================================
		Additional Function
	/================================================*/
	const loginLeftStyles = {
		backgroundImage: `url("./sgtradex-cover-login.png")`
	}

	/*=================================================
		Navigate
	/================================================*/
	function goToResetTfa() {
		return window.open(`${adminUrl}/reset-2fa`, '_blank')
	}

	/*=================================================
		MultiDex
	/================================================*/
	const { dex } = getEnvAndDex();
	const { dexName } = getDexConfig(dex);

	return (
		<div className='layout-login'>
			<DexLeftComponent />

			<div className='layout-login__right layout-login__right--grey'>
				<div className='set-up-tfa'>
					<div className='set-up-tfa__title--header-1'>Activate <br /> Two Factor Authentication</div>
					<div className='set-up-tfa__sub-header'>Scan the below QR Code or Input the Secret Key in Google Authenticator Mobile App and generate a Security Code.</div>
					<div className='set-up-tfa__content'>
						<div className="set-up-tfa__content__top">
							<div className="set-up-tfa__content__top__left">
								<span className='set-up-tfa__label'>QR Code</span>
								<div className="set-up-tfa__content__qr-image--outer">
									<span className='set-up-tfa__content__qr-image-inner'>
										<QRCodeSVG
											value={ feature(features.ONBOARDING_V2) ? `otpauth://totp/${dexName}:${user?.email}?secret=${currentItemTwoFactorAuthentication?.secret}&issuer=SGTraDex` : "otpauth://totp/SGTraDex:" + user?.email + "?secret=" + currentItemTwoFactorAuthentication?.secret + "&issuer=SGTraDex"}
											size={105}
											bgColor={"#ffffff"}
											fgColor={"#000000"}
											level={"L"}
											includeMargin={false}
										/>
									</span>
								</div>
							</div>
							<div className="set-up-tfa__content__top__right">
								<span className="set-up-tfa__label">Secret Key</span>
								<div className='set-up-tfa__content__secret'>
									<Input
										defaultValue={currentItemTwoFactorAuthentication?.secret}
										type={customMask ? 'password' : 'text'}
										disabled={true}
										data-testid="secret-input"
									/>
									<span data-testid="reveal-btn" className="link set-up-tfa__content__top__right--eye" onClick={() => setCustomMask(!customMask)}>
										<IconEye bool={customMask} />
									</span>
								</div>
							</div>
						</div>
						<div className="set-up-tfa__content__bottom">
							<form id="tfaForm" onSubmit={handleSubmit(formHandler)}>
								{errorMessage && (
									<div className='login-box__form__col--error'>
										<Error /> <span className='t--required'>{errorMessage}</span>
									</div>
								)}
								<span className="set-up-tfa__label">Input Security Code Generated by Google Authenticator</span>
								<Input
									maxWidth="360"
									name="otp"
									placeholder="000000"
									register={register({
										required: "This field is mandatory",
										minLength: {
											value: 6,
											message: "Please enter a valid OTP"
										}
									})}
									error={errors.otp}
									errorMessage={errors.otp?.message}
									maxLength={6}
									type="number"
									data-testid="otp-input"
								/>
							</form>
						</div>
						<div className="set-up-tfa__content__action">
							<div className="set-up-tfa__content__action__top">
								<Button
									type='submit' maxWidth="240"
									full round value='Submit'
									text="Verify & Activate"
									disabled={!isValid}
									loading={loading}
									form={"tfaForm"}
								/>
							</div>
							<div className="set-up-tfa__content__action__bottom">
								<span className="link" onClick={()=>goToResetTfa()}>Trouble Logging In?</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
export default Page
